/*!
 * PETQuarters PDP loyalty balance v1.0.2
 * Read-only display. THQ offer counts are rendered in Liquid; this file reads only Yotpo points.
 * Yotpo app.v1.0.368 emits jQuery OR native document events; it has no public swellAPI.on.
 * A setup event / getter / refresh callback is NOT a successful balance read. Only accept a
 * finite balance after swell:customer:updated and a canonical signed-in identity match.
 * No account data in browser storage, no counter/reward writes, no cart/checkout handlers.
 */
(function () {
  'use strict';
  if (window.PQPdpLoyaltyBalance) { window.PQPdpLoyaltyBalance.bind(); return; }
  var PANEL = '[data-pq-rewards][data-signed-in="true"]';
  var WAIT_MS = 20000, POLL_MS = 250, INITIAL_GRACE_MS = 1000, FRESH_MS = 120000;
  var state = {
    key: '', identityLost: false, reloadRequired: false, phase: 'idle', lastGood: null,
    deadline: 0, sdkSeenAt: 0, requested: false, lateSetupRecovered: false
  };
  var timer = null, frame = null, observer = null, destroyed = false;
  var jqueryInstances = [], nativeHandlers = [];

  function normalize(s) { return String(s || '').trim().toLowerCase(); }
  function signedPanels() { return Array.prototype.slice.call(document.querySelectorAll(PANEL)); }
  function readIdentity() {
    var el = document.getElementById('swell-customer-identification');
    if (!el || el.getAttribute('data-authenticated') !== 'true') return null;
    var id = String(el.getAttribute('data-id') || '').trim();
    var email = normalize(el.getAttribute('data-email'));
    if (!id || !email) return null;
    return { id: id, email: email, key: id + '\n' + email };
  }
  function stopTimer() { if (timer !== null) { clearInterval(timer); timer = null; } }
  function syncIdentity() {
    var identity = readIdentity();
    if (!identity) {
      if (state.key) { state.lastGood = null; state.identityLost = true; state.reloadRequired = true; state.phase = 'unavailable'; stopTimer(); }
      return null;
    }
    if (!state.key) state.key = identity.key;
    else if (state.key !== identity.key || state.identityLost) {
      // Account switching needs a new server-rendered page. Never reuse points or accept an
      // in-flight old-account response on this document, even if SDK identity later changes.
      state.lastGood = null; state.reloadRequired = true; state.phase = 'unavailable'; stopTimer();
    }
    return identity;
  }
  function text(el, value) { if (el && el.textContent !== value) el.textContent = value; }
  function attr(el, name, value) { if (el.getAttribute(name) !== value) el.setAttribute(name, value); }
  function toggleHidden(el, hide) { if (el && el.hidden !== hide) el.hidden = hide; }
  function render() {
    var identity = syncIdentity();
    var good = identity && !state.reloadRequired && state.lastGood && state.lastGood.key === identity.key ? state.lastGood : null;
    signedPanels().forEach(function (panel) {
      var balance = panel.querySelector('[data-pq-points-balance]');
      if (!balance) return;
      var retry = panel.querySelector('[data-pq-points-retry]');
      var note = panel.querySelector('[data-pq-balance-note]');
      var panelIdentityMatches = identity && String(panel.getAttribute('data-customer-id') || '') === identity.id;
      var value, noteText = '', mode = state.phase;
      if (!panelIdentityMatches || state.reloadRequired) {
        var awaitingIdentity = !identity && !state.identityLost && (state.phase === 'loading' || state.phase === 'idle');
        value = awaitingIdentity ? (panel.getAttribute('data-balance-loading') || 'Loading…') : (panel.getAttribute('data-balance-unavailable') || 'Temporarily unavailable');
        mode = awaitingIdentity ? 'loading' : 'unavailable';
        if (state.reloadRequired) noteText = panel.getAttribute('data-balance-reload-note') || 'Refresh this page to load the signed-in account.';
      } else if (good) {
        value = good.balance.toLocaleString('en-AU') + (panel.hasAttribute('data-balance-suffix') ? panel.getAttribute('data-balance-suffix') : ' pts');
        if (state.phase === 'loading') { mode = 'refreshing'; noteText = panel.getAttribute('data-balance-updating') || 'Updating…'; }
        if (state.phase === 'unavailable') noteText = panel.getAttribute('data-balance-stale') || 'Last confirmed balance; refresh is unavailable.';
      } else if (state.phase === 'loading' || state.phase === 'idle') {
        value = panel.getAttribute('data-balance-loading') || 'Loading…'; mode = 'loading';
      } else {
        value = panel.getAttribute('data-balance-unavailable') || 'Temporarily unavailable'; mode = 'unavailable';
      }
      text(balance, value); attr(balance, 'data-pq-len', String(value.length)); text(note, noteText); toggleHidden(note, !noteText);
      attr(balance, 'data-balance-state', mode);
      attr(balance, 'aria-busy', mode === 'loading' || mode === 'refreshing' ? 'true' : 'false');
      if (retry) {
        text(retry, state.reloadRequired ? (panel.getAttribute('data-balance-reload-label') || 'Refresh page') : (panel.getAttribute('data-balance-retry') || 'Try again'));
        toggleHidden(retry, mode !== 'unavailable');
        if (!retry.__pqLoyaltyBound) {
          retry.__pqLoyaltyBound = true;
          retry.addEventListener('click', function () {
            if (state.reloadRequired) { window.location.reload(); return; }
            begin(true);
          });
        }
      }
    });
  }
  function sdk() {
    var api = window.swellAPI;
    return api && typeof api.getCustomerDetails === 'function' ? api : null;
  }
  function matchingDetails(identity) {
    var api = sdk();
    if (!api || !identity || state.reloadRequired) return null;
    try {
      var details = api.getCustomerDetails();
      return details && normalize(details.email) && normalize(details.email) === identity.email ? details : null;
    } catch (e) { return null; }
  }
  function finiteBalance(details) {
    if (!details) return null;
    var value = details.pointsBalance;
    if (typeof value !== 'number' && !(typeof value === 'string' && /^[+-]?\d+(?:\.\d+)?$/.test(value.trim()))) return null;
    var number = Number(value);
    return isFinite(number) ? number : null;
  }
  function customerUpdated() {
    if (destroyed || !signedPanels().length) return;
    attachJquery();
    var identity = syncIdentity();
    var balance = finiteBalance(matchingDetails(identity));
    if (!identity || state.reloadRequired || balance === null) { render(); return; }
    state.lastGood = { key: identity.key, balance: balance, at: Date.now() };
    state.phase = 'ready'; state.requested = false; stopTimer(); render();
  }
  function setup() {
    if (destroyed || !signedPanels().length) return;
    attachJquery(); syncIdentity();
    // Setup runs for guests and refresh errors too; it can restart a timed-out wait once,
    // but must never certify the getter's default zero as a real balance.
    if (state.phase === 'unavailable' && !state.reloadRequired && !state.lateSetupRecovered) {
      state.lateSetupRecovered = true; begin(true); return;
    }
    if (state.phase === 'idle') begin(false); else step();
  }
  function redeemed() { if (!destroyed && signedPanels().length) begin(true); }
  var sdkEvents = { 'swell:setup': setup, 'swell:customer:updated': customerUpdated, 'swell:redemption': redeemed };
  function attachJquery() {
    [window.jQuery, window.$].forEach(function (jq) {
      if (typeof jq !== 'function' || !jq.fn || typeof jq.fn.on !== 'function' || jqueryInstances.indexOf(jq) !== -1) return;
      try {
        var target = jq(document);
        Object.keys(sdkEvents).forEach(function (event) { target.on(event + '.pqPdpLoyalty', sdkEvents[event]); });
        jqueryInstances.push(jq);
      } catch (e) { /* optional interface; native listener + bounded retry remain */ }
    });
  }
  function step() {
    if (destroyed) return;
    attachJquery();
    if (!signedPanels().length) { stopTimer(); return; }
    var identity = syncIdentity();
    if (state.reloadRequired || state.phase !== 'loading') { render(); return; }
    if (Date.now() >= state.deadline) { state.phase = 'unavailable'; stopTimer(); render(); return; }
    var api = sdk(), details = matchingDetails(identity);
    if (api && details) {
      if (!state.sdkSeenAt) state.sdkSeenAt = Date.now();
      if (!state.requested && Date.now() - state.sdkSeenAt >= INITIAL_GRACE_MS && typeof api.refreshCustomerDetails === 'function') {
        state.requested = true;
        try {
          // Bound listeners FIRST. The SDK's callback runs on failure as well as success;
          // deliberately do not mark the balance ready from that callback.
          api.refreshCustomerDetails(function () { /* success comes only through customerUpdated */ });
        } catch (e) { state.phase = 'unavailable'; stopTimer(); }
      }
    }
    render();
  }
  function begin(force) {
    if (destroyed || !signedPanels().length) return;
    var identity = syncIdentity();
    attachJquery();
    if (state.reloadRequired) { render(); return; }
    if (state.phase === 'loading') { render(); return; }
    if (!force && identity && state.lastGood && state.lastGood.key === identity.key && Date.now() - state.lastGood.at < FRESH_MS) {
      state.phase = 'ready'; render(); return;
    }
    state.phase = 'loading'; state.deadline = Date.now() + WAIT_MS; state.sdkSeenAt = 0; state.requested = false;
    stopTimer(); timer = setInterval(step, POLL_MS); step();
  }
  function bind() {
    if (destroyed) return;
    attachJquery(); syncIdentity();
    if (!signedPanels().length) { stopTimer(); return; }
    if (state.phase === 'idle' || (state.phase === 'ready' && state.lastGood && Date.now() - state.lastGood.at >= FRESH_MS)) begin(false);
    else { render(); if (state.phase === 'loading' && timer === null) { timer = setInterval(step, POLL_MS); step(); } }
  }
  function scheduleBind() {
    if (destroyed || frame !== null) return;
    frame = requestAnimationFrame(function () { frame = null; bind(); });
  }
  function relevantNode(node) {
    return node && node.nodeType === 1 && (node.matches('[data-pq-rewards],#swell-customer-identification') || node.querySelector('[data-pq-rewards],#swell-customer-identification'));
  }
  function listen(event, fn, target) {
    (target || document).addEventListener(event, fn);
    nativeHandlers.push({ target: target || document, event: event, fn: fn });
  }
  function boot() {
    if (destroyed) return;
    if (!observer && document.body) {
      observer = new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          if (mutation.type === 'attributes') return true;
          return Array.prototype.some.call(mutation.addedNodes, relevantNode) || Array.prototype.some.call(mutation.removedNodes, relevantNode);
        });
        if (relevant) scheduleBind();
      });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-email','data-id','data-authenticated','data-signed-in','data-customer-id'] });
    }
    bind();
  }
  function destroy() {
    destroyed = true; stopTimer();
    if (frame !== null) { cancelAnimationFrame(frame); frame = null; }
    if (observer) observer.disconnect();
    nativeHandlers.forEach(function (entry) { entry.target.removeEventListener(entry.event, entry.fn); });
    jqueryInstances.forEach(function (jq) { try { jq(document).off('.pqPdpLoyalty'); } catch (e) {} });
    state.lastGood = null; state.key = ''; jqueryInstances = []; nativeHandlers = [];
  }
  Object.keys(sdkEvents).forEach(function (event) { listen(event, sdkEvents[event]); });
  listen('shopify:section:load', scheduleBind);
  listen('pageshow', function () { if (signedPanels().length) begin(true); }, window);
  listen('visibilitychange', function () { if (document.visibilityState === 'visible') bind(); });
  window.PQPdpLoyaltyBalance = { version: '1.0.2', bind: bind, refresh: function () { begin(true); }, destroy: destroy };
  attachJquery();
  if (document.readyState === 'loading') listen('DOMContentLoaded', boot); else boot();
})();
